import { api } from "../lib/axios";

import type { ApiData } from "./apiData";
import type { VectorApiParams } from "./createNamespace";

interface UpdateNamespaceNameBody {
    newPodName: string
}

interface UpdateNamespaceNameData {
    message: string
}

type UpdateNamespaceNameResponse = ApiData<UpdateNamespaceNameData>

async function updateNamespaceName({
    body,
    params
}: {
    body: UpdateNamespaceNameBody,
    params: VectorApiParams
}) {
    const response = await api.put<UpdateNamespaceNameResponse>(
        '/vector/change-name',
        body,
        { params }
    )

    return response.data
}

export {
    updateNamespaceName,
    type UpdateNamespaceNameBody,
    type UpdateNamespaceNameResponse
}